import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import Utils from 'utils/Utils';
import * as actions from 'actions/response';
import * as constants from 'constants.js';
import ClaroUrlBuilder from 'utils/ClaroUrlBuilder';
import { converter } from 'helpers/converter';
import * as actionsMetrics from 'action-creators/metrics';
import _ from 'lodash';
import {
  extractAction,
  getLinkActionPurchase,
  getSrcBannersPromo,
  validateSerie,
} from './SectionPurchaseUtil';
import DownloadButton from './DownloadButton';
import PurchaseButton from './PurchaseButton';
import DateButton from './DateButton';
import BannerPromo from './BannerPromo';
import TrailerButton from './TrailerButton';
import PlayButton from './PlayButton';

class SectionPurchase extends Component {
  constructor(props) {
    super(props);

    this.redirectToPayment = this.redirectToPayment.bind(this);
    this.renderPurchaseButtons = this.renderPurchaseButtons.bind(this);
    this.renderButtons = this.renderButtons.bind(this);
    this.handleAcceptNotPlayable = this.handleAcceptNotPlayable.bind(this);
    this.bpKey = '';
    this.bpSrc = {
      portrait: '',
      landscape: '',
    };
    this.bpConfig = {};
    this.buttonModal = {};
    this.init(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.metadata !== nextProps.metadata ||
      this.props.purchaseInfo !== nextProps.purchaseInfo
    ) {
      this.init(nextProps);
    }
  }

  onPurchaseClick = async button => {
    const purchaseInfo = this.props.purchaseInfo;
    let genero = null;

    if (typeof purchaseInfo.accessCode !== 'undefined') {
      if (purchaseInfo.accessCode.enabled) {
        if (this.props.contentData.extendedcommon.genres) {
          genero = this.props.contentData.extendedcommon.genres.genre[0].desc;
        }

        const modal = {
          modalType: 'Pin',
          props: {
            button,
            groupResult: this.props.groupResult,
            nodeId: this.props.params.nodeId,
            hrefMyAccount: ClaroUrlBuilder.myAccount(this.props.user.region),
            genero,
          },
        };

        this.props.showModal(modal);
        throw new Error('Pin');
      }
    }
    return 'OK';
  };

  onPreview = () => {
    let eventAction;
    eventAction = 'Ver trailer';
    this.callMetrics(eventAction);

    window.location = ClaroUrlBuilder.preview(this.props.groupResult.id);
  };

  setMetrics(label, action) {
    const eventCategory = 'vcard';
    const eventAction = action;
    const eventLabel = label;

    this.props.setMetricsEvent({
      tagManager: {
        event: 'click',
        eventCategory,
        eventAction,
        eventLabel,
      },
    });

    this.props.setMetricsEvent({
      type: 'executor',
      success: true,
    });
  }

  getDetailOfferNote() {
    if (this.props.metadata.detail_offer_note) {
      try {
        return JSON.parse(this.props.metadata.detail_offer_note);
      } catch (e) {
        // console.log('unable to parse detail offer note');
        return null;
      }
    }
    return null;
  }

  callMetrics = eventAction => {
    let eventLabel;
    let genero = null;
    const { groupResult } = this.props;
    const isSerie = validateSerie(groupResult);
    const queryParams = {
      title: this.props.contentData.title,
      titleUri: this.props.contentData.title_uri,
    };
    if (this.props.contentData.extendedcommon.genres) {
      genero = this.props.contentData.extendedcommon.genres.genre[0].desc;
      queryParams.genero = genero;
    }
    let type = this.props.contentData.extendedcommon.format.sell_type;
    if (type == 'susc') {
      type = this.props.contentData.extendedcommon.media.proveedor.nombre;
      if (type == 'AMCO') type = 'susc';
    }
    if (isSerie) {
      const nameSerie = groupResult.extendedcommon.media.serie.title;
      eventLabel = `${queryParams.genero} - ${nameSerie} | ${
        groupResult.title
      } - ${type}`;
    } else {
      eventLabel = `${queryParams.genero} - ${groupResult.title} - ${type}`;
    }
    this.setMetrics(eventLabel, eventAction);
  };

  redirectToPayment = async (button, isbutton) => {
    let eventLabel;
    let eventAction;
    const provider = button.producttype;
    const groupResult = this.props.groupResult;
    const isSerie = validateSerie(groupResult);
    const urlPlayer = ClaroUrlBuilder.player(groupResult.id);
    const oneofferdesc = button.oneofferdesc;
    let rentParam = '';
    let genero = null;

    const queryParams = {
      group_id: groupResult.id,
      offer_id: button.offerid,
      player_url: urlPlayer,
      oneoffertype: button.oneoffertype,
      oneofferdesc: button.oneofferdesc,
      title: this.props.contentData.title,
      titleUri: this.props.contentData.title_uri,
    };

    const liveppe =
      this.props.contentData.extendedcommon &&
      this.props.contentData.extendedcommon.media &&
      this.props.contentData.extendedcommon.format &&
      this.props.contentData.extendedcommon.media.islive == '1' &&
      this.props.contentData.extendedcommon.format.sell_type == 'ppe';
    if (button.linkworkflowstart) {
      queryParams.linkworkflowstart = button.linkworkflowstart;
    }

    if (oneofferdesc.indexOf('24') > -1) {
      rentParam = '24';
      eventAction = 'Renta 24hs';
    }

    if (oneofferdesc.indexOf('48') > -1) {
      rentParam = '48';
      eventAction = 'Renta 48hs';
    }

    if (button.oneoffertype == 'download_buy') {
      rentParam = 'compra';
      eventAction = 'compra';
    }

    if (button.oneoffertype && button.oneoffertype.indexOf('event') != -1) {
      if (
        groupResult &&
        groupResult.extendedcommon &&
        groupResult.extendedcommon.media &&
        groupResult.extendedcommon.media.islive == '0'
      ) {
        rentParam = '24';
        eventAction = 'Renta 24hs';
      } else {
        rentParam = 'event_live';
        eventAction = 'live';
      }
    }

    if (this.props.contentData.extendedcommon.genres) {
      genero = this.props.contentData.extendedcommon.genres.genre[0].desc;
      queryParams.genero = genero;
    }

    if (button.oneoffertype != 'subscrition') {
      queryParams.isrent = rentParam;
      queryParams.offertype = button.oneoffertype;
    } else {
      let bannerpromo;
      let action;
      try {
        bannerpromo = this.props.purchaseInfo.bannerpromo;
        const promo_configuration = JSON.parse(
          this.props.metadata.product_promo_configuration,
        );
        action = promo_configuration[bannerpromo].action;
      } catch (err) {
        console.error('NO_ACTION_BTN_PURCHASE', bannerpromo);
        action = null;
        bannerpromo = null;
      }
      if (!isbutton && bannerpromo !== null && action !== null)
        eventAction = 'activar promocion';
      else eventAction = extractAction(oneofferdesc, provider);
    }

    if (isSerie) {
      const nameSerie = groupResult.extendedcommon.media.serie.title;
      eventLabel = `${oneofferdesc} - ${queryParams.genero} - ${nameSerie} | ${
        groupResult.title
      }`;
    } else {
      eventLabel = `${oneofferdesc} - ${queryParams.genero} - ${
        groupResult.title
      }`;
    }

    if (this.props.user.userType == constants.ANONYMOUS_USER) {
      this.setMetrics(eventLabel, eventAction);
      if (queryParams.isrent) {
        queryParams.login = null;
        return queryParams;
      }

      queryParams.login = null;
      return queryParams;
    }

    this.setMetrics(eventLabel, eventAction);
    return queryParams;
  };

  handleClickPurchaseButton = async button => {
    try {
      await this.beforePurchaseClick(button, this.handleAcceptNotPlayable);
      await this.onPurchaseClick(button);
      this.redireccionaPagos(button);
    } catch (e) {
      console.error(e);
    }
  };

  handleAcceptNotPlayable() {
    if (!_.isEmpty(this.buttonModal)) {
      this.handleClickPurchaseButton(this.buttonModal);
    }
  }

  redireccionaPagos = async button => {
    try {
      const queryParams = await this.redirectToPayment(button, true);
      queryParams.price = button.price || '';
      const link = getLinkActionPurchase({
        userType: this.props.user.userType,
      });

      browserHistory.push({
        pathname: link,
        query: queryParams,
      });
    } catch (e) {
      console.error(e);
    }
  };

  handleClickBannerPromo = async () => {
    try {
      const button = this.props.purchaseInfo.listButtons.button.find(
        b => b.bannerpromo === this.bpKey,
      );
      const isbutton = false;

      await this.beforePurchaseClick(button);

      await this.onPurchaseClick(button);

      const queryParams = await this.redirectToPayment(button, isbutton);

      const link = getLinkActionPurchase({
        userType: this.props.user.userType,
      });
      if (link !== null) {
        browserHistory.push({
          pathname: link,
          query: queryParams,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  init(props) {
    try {
      this.bpConfig = JSON.parse(props.metadata.product_promo_configuration);
    } catch (e) {
      this.bpConfig = {};
    }
    if (props.purchaseInfo) {
      this.bpKey = props.purchaseInfo.bannerpromo;
      this.bpSrc = getSrcBannersPromo(
        props.asset,
        props.purchaseInfo.bannerpromo,
      );
    }
  }

  beforePurchaseClick = async (button, callback) => {
    const encodes =
      this.props.metadata.product_encodes_configuration &&
      JSON.parse(this.props.metadata.product_encodes_configuration);
    const canPlay = Utils.deviceCanPlay(button.producttype, encodes);
    if (!canPlay && _.isEmpty(this.buttonModal)) {
      const modal = {
        modalType: 'CannotPlay',
        props: {
          provider: button.producttype,
          onAccept: callback,
        },
      };
      this.props.showModal(modal);
      this.buttonModal = button;
      throw new Error('CannotPlay');
    }
    return 'OK';
  };

  renderButtons() {
    const purchaseInfo = this.props.purchaseInfo;
    let isRentDisabled = false;
    try {
      isRentDisabled =
        this.props.purchaseInfo.errors.completeError.errors.code ===
        'net_rent_disabled';
    } catch (e) {
      isRentDisabled = false;
    }

    if (isRentDisabled || typeof purchaseInfo.listButtons === 'undefined') {
      return [];
    }

    return purchaseInfo.listButtons.button.filter(
      button => !button.withDownload,
    );
  }

  renderPurchaseButtons() {
    const purchaseInfo = this.props.purchaseInfo;
    let isRentDisabled = false;
    try {
      isRentDisabled =
        this.props.purchaseInfo.errors.completeError.errors.code ===
        'net_rent_disabled';
    } catch (e) {
      isRentDisabled = false;
    }

    if (isRentDisabled || typeof purchaseInfo.listButtons === 'undefined') {
      return [];
    }
    /*
    return [
      ...purchaseInfo.listButtons.button.filter(button => button.withDownload),
      ...purchaseInfo.listButtons.button.filter(button => !button.withDownload)
    ];
    */

    const buttonsOrdered = _.orderBy(purchaseInfo.listButtons.button, [
      'withDownload',
    ]);

    return buttonsOrdered.map(button => {
      if (
        button.startdate &&
        button.waspurchased &&
        purchaseInfo.playButton.visible === '1'
      ) {
        return <DateButton {...this.props} button={button} />;
      }
      return (
        <PurchaseButton
          {...this.props}
          button={button}
          onClickPurchase={this.handleClickPurchaseButton}
        />
      );
    });
  }

  render() {
    if (
      !this.props.contentData ||
      !this.props.metadata ||
      this.props.metadata.metadata ||
      this.props.user == null ||
      this.props.purchaseInfo == null
    ) {
      return null;
    }

    // .response.group.common.extendedcommon.media.islive
    const purchaseInfo = this.props.purchaseInfo;

    let pin = null;
    let pinIcon = null;
    let pinLabel = converter.convertApaUnicode(
      this.props.translations,
      'secure_website',
      'Sitio Seguro',
    );
    let discSemanal = null;
    let sellType = null;
    if (
      this.props.contentData &&
      this.props.contentData.extendedcommon &&
      this.props.contentData.extendedcommon.format &&
      this.props.contentData.extendedcommon.format.sell_type
    ) {
      sellType = this.props.contentData.extendedcommon.format.sell_type;
    }

    // /leyenda plan semana
    const detail_offer_note = this.getDetailOfferNote();
    let offer_note_by_region = null;
    if (detail_offer_note) {
      offer_note_by_region = detail_offer_note[constants.GetRegion()];
    }
    const userType = this.props.user.userType.toLowerCase();
    let subscritionWithUserType = null;
    if (offer_note_by_region && sellType) {
      subscritionWithUserType = offer_note_by_region[sellType];
    }
    if (subscritionWithUserType && userType) {
      subscritionWithUserType = subscritionWithUserType[userType];
    }

    let leyenda = null;
    if (subscritionWithUserType) {
      leyenda = this.props.translations[subscritionWithUserType];
    }

    let textLeyenda = null;
    if (leyenda) {
      textLeyenda = leyenda;
    }
    if (
      textLeyenda &&
      this.props.contentData &&
      this.props.contentData.extendedcommon &&
      this.props.contentData.extendedcommon.media &&
      this.props.contentData.extendedcommon.media.proveedor &&
      this.props.contentData.extendedcommon.media.proveedor.nombre == 'AMCO'
    ) {
      discSemanal = (
        <div className="">
          <span>{textLeyenda}</span>
        </div>
      );
    }

    if (this.props.user.userType !== constants.ANONYMOUS_USER) {
      const showAccesCode =
        this.props.contentData.extendedcommon.format.types &&
        this.props.contentData.extendedcommon.format.types
          .split(',')
          .some(type => type === 'ppe' || type === 'est');

      const wasPurchased =
        purchaseInfo.playButton && purchaseInfo.playButton.waspurchased;

      // ACCESS_CODE
      if (showAccesCode || !wasPurchased) {
        pinLabel = (
          <span>
            {converter.convertApaUnicode(
              this.props.translations,
              'pay_code_enabled',
            )}
          </span>
        );

        if (purchaseInfo.accessCode && !purchaseInfo.accessCode.enabled) {
          pinLabel = (
            <span>
              {converter.convertApaUnicode(
                this.props.translations,
                'pay_code_disabled_hint',
              )}
            </span>
          );

          pinIcon = <i className="fa fa-unlock" />;
          const hrefMyAccount = ClaroUrlBuilder.myAccount(
            this.props.user.region,
          );
          pin = (
            <a className="label-purchase" href={hrefMyAccount}>
              {pinIcon} {pinLabel}
            </a>
          );
        } else {
          pinIcon = <i className="fa fa-lock" />;
          pin = (
            <a className="label-purchase">
              {pinIcon} {pinLabel}
            </a>
          );
        }
      }
    }

    try {
      if (
        this.props.purchaseInfo.errors.completeError.errors.code ===
        'net_rent_disabled'
      ) {
        pin = null;
      }
    } catch (e) {}

    const isThereAction = typeof this.bpConfig[this.bpKey] !== 'undefined';
    const isBtnDownloadVisible =
      this.props.purchaseInfo.downloadButton.visible === '1' &&
      !this.props.isSerie;

    return (
      <div>
        <BannerPromo
          isThereAction={isThereAction}
          {...this.bpSrc}
          onClickBanner={this.handleClickBannerPromo}
        />

        <TrailerButton
          visible={this.props.contentData.hasPreview}
          onPreview={this.onPreview}
          translations={this.props.translations}
        />

        <PlayButton {...this.props} callMetrics={this.callMetrics} />

        {this.renderPurchaseButtons()}

        {discSemanal}

        <DownloadButton
          {...this.props}
          callMetrics={this.callMetrics}
          visible={isBtnDownloadVisible}
        />

        <div className="hidden-xs">{pin}</div>
      </div>
    );
  }
}

SectionPurchase.propTypes = {
  config: PropTypes.object,
  contentData: PropTypes.object,
  groupResult: PropTypes.object,
  metadata: PropTypes.object,
  purchaseInfo: PropTypes.object,
  translations: PropTypes.object,
  user: PropTypes.object,
  showModal: PropTypes.func.isRequired,
  setMetricsEvent: PropTypes.func.isRequired,
  params: PropTypes.object,
  asset: PropTypes.object,
  isSerie: PropTypes.bool,
  onDownload: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  asset: state.asset,
  metadata: state.metadata,
  router: state.routing,
  contentData: state.card.contentData,
  groupResult: state.card.contentData,
  purchaseInfo: state.card.purchaseInfo,
  errorData: state.card.errorData,
  user: state.user,
  config: state.config,
  translations: state.translations,
});

SectionPurchase.defaultProps = {
  isSerie: true,
};

const mapDispatchToProps = dispatch => ({
  showModal(modal) {
    dispatch(actions.showModal(modal));
  },
  setMetricsEvent(options) {
    dispatch(actionsMetrics.setMetricsEvent(options));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SectionPurchase);
